import { nFormatter } from "@/common/utils/parseNumber";
import { LikeIcon } from "@/components/UI/LikeIcon";
import UnlikedIcon from "@/common/images/icons/unliked.svg?react";
import "./LikeButton.scss";

interface ILikeButtonProps {
  liked: boolean;
  count: number;
  id: string;
  onClick: () => void;
}

export const LikeButton = ({ onClick, liked, count }: ILikeButtonProps) => {
  return (
    <button className="LikeButton" onClick={onClick} aria-label="toggle like button">
      {liked ? <LikeIcon /> : <UnlikedIcon />}
      <span className="label">{nFormatter(count)}</span>
    </button>
  );
};
